/**
 * utils 工具库
 *@clone 深拷贝对象数组 本地属性。忽略 函数,日期, symbol
 *@realType 获取一个数据的真实类型
 *@extend params (Object...) 接收n个Object，忽略其他类型，递归覆盖
 * Created by liux on 2017/12/13.
 */
function clone(object, extension) {
  var tmp = null;
  var type = realType(object);
  var index = ['array', 'object'].indexOf(type);
  if (index !== -1) {
    switch (index) {
      case 0:
        tmp = [];
        object.forEach((item, index) => {
          let result = clone(item, extension);
          tmp[index] = result;
        });
        break;
      case 1:
        tmp = {};
        for (let key in object) {
          if (object.hasOwnProperty(key)) {
            let result = clone(object[key], extension);
            if(extension === 'underscore2camelCase'){
              key =  key.replace(/_(\w)/g, function(all, letter){
                return letter.toUpperCase();
              });
            }
            tmp[key] = result;
          }
        }
        break;
      default:
        break;
    }

    return tmp;
  } else {
    if (['number', 'string', 'null', 'undefined', 'boolean'].indexOf(realType(object)) !== -1) {
      tmp = object;
    }
    return tmp;
  }
}



function realType(o) {
  return Object.prototype.toString.call(o).slice(8, -1).toLowerCase();
};

function parse(value) {
  var re = '';
  try {
    re = JSON.parse(value);
  } catch (err) {
    return value;
  }
  return re;
}

function extend(...arr) {
  arr = arr.filter(item => {
    return realType(item) === 'object';
  });
  if (arr.length <= 1) return arr[0];
  return arr.reduce(function(previousValue, currentValue) {
    return recursive(previousValue, currentValue);
  });

}

function recursive(taget={}, source) {
  for (var key in source) {
    if (realType(source[key]) !== 'object') {
      taget[key] = source[key];
    } else {
      if(realType(taget[key]) === 'object'){
        taget[key] = recursive(taget[key], source[key]);
      }else {
        taget[key] = recursive({}, source[key]);
      }
    }
  }
  return taget;
}


function underscore2camelCase(object) {
  return clone(object,'underscore2camelCase')
}

//替换域名
function replaceDomain(url) {
  let domain = location.host.split('.')[1];
  if(process.env.NODE_ENV === 'development'){
    return url;
  }
  return url.replace(url.split('.')[1],domain);
}

export {
  clone,
  realType,
  parse,
  extend,
  underscore2camelCase,
  replaceDomain
};




// WEBPACK FOOTER //
// ./node_modules/bjxy-common/helper/utils.js